import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { Row, Col, Button } from 'react-bootstrap'
import { i18nTranslate, convertToBoolean, isFeatureEnabled } from 'src/utils'
import { customerContainer, userContainer } from 'src/models'
import { APPConfig } from 'config/appConfig'
import { isB2B2C } from 'src/utils'
import { AccordionBlock, CommonForm } from 'src/views/components'
import './styles.scss'
import { renderUserInviteFormInput } from './userInviteFormInput'
import { userInviteFormschema } from './validationSchema'
import { dummyEmailRegex } from '../fixture'

@observer
class UsersListCard extends React.Component {
  @observable isActive = false
  @observable userId = ''
  @observable isEmailOpen = false
  @observable migratedUserId = ''

  toggleEditUser = props => {
    this.userId = props.index
    this.isActive = props.isOpen
  }

  handleResendInvitation = async (id = '') => {
    const payload = {
      associateUserId: id?.toString(),
    }
    await userContainer.sendAssociateInvitationLink(payload)
  }

  handleDeleteIvitation = async (id = '', userId = '') => {
    const payload = {
      associateUserId: id?.toString(),
      associateBuyerId: userId?.toString(),
      invitationStatus: 'INVITATION_WITHDRAWN',
    }
    await userContainer.deleteAssociateInvitationLink(payload)
  }

  handleAddEmail = (id = '') => {
    this.isEmailOpen = !this.isEmailOpen
    this.migratedUserId = id
  }

  sendMigratedUserInvitation = async (data = {}, id = '') => {
    const payload = {
      associateUserId: id?.toString(),
      email: data?.email || '',
    }
    await userContainer.sendAssociateInvitationLink(payload)
    this.isEmailOpen = false
  }

  renderUserListHeader = user => {
    // const { id, email, status = '', firstName, lastName, team } = user
    const {
      email = '',
      firstName = '',
      lastName = '',
      phoneNumber = '',
      customProperties = {},
      status = '',
    } = user
    const statusText = status.toLowerCase()
    const statusLabel =
      statusText === 'notactivated'
        ? i18nTranslate('status.invited', 'Invited')
        : statusText === 'active'
          ? i18nTranslate('status.active', 'Active')
          : status
    const statusStyle =
      statusText === 'notactivated'
        ? 'text-uppercase text-secondary'
        : statusText === 'active'
          ? 'text-uppercase status-active-text-color'
          : 'text-uppercase text-danger'
    const adminEmail = customerContainer?.profileResponse?.email || ''
    const isAdminEmail = adminEmail === email
    const role = isAdminEmail
      ? i18nTranslate('user.admin', 'Admin')
      : i18nTranslate('user.user', 'User')

    return (
      <div className="user-list">
        <Row noGutters>
          <Col>
            <div
              data-testid="qa-user-name"
              className="user-list-item mb-1 user-colon-align">
              <span className="font-weight-bold">
                {i18nTranslate('users.firstName', 'First Name')}
              </span>
              <span>: {firstName}</span>
            </div>
            <div
              data-testid="qa-user-name"
              className="user-list-item mb-1 user-colon-align">
              <span className="font-weight-bold">
                {i18nTranslate('users.lastName', 'Last Name')}
              </span>
              <span>: {lastName}</span>
            </div>
            {phoneNumber && (
              <div
                data-testid="qa-contact"
                className="user-list-item mb-1 user-colon-align">
                <span className="font-weight-bold">
                  {i18nTranslate('user.contact', 'Contact')}
                </span>
                <span>: {phoneNumber}</span>
              </div>
            )}
          </Col>
          <Col>
            <div
              data-testid="qa-email"
              className="user-list-item mb-1 user-colon-align">
              <span className="font-weight-bold">
                {i18nTranslate('user.email', 'Email')}
              </span>
              <span className="toLowerCase">
                :{'  '} {dummyEmailRegex.test(email) ? '' : email}
              </span>
              {user?.status === 'ACTIVE' &&
                customProperties?.associateInvitationStatus ===
                  'INVITATION_SENT' &&
                email !== '' &&
                !dummyEmailRegex.test(email) && (
                  <span className="text-danger font-weight-bold">
                    {' '}
                    {i18nTranslate(
                      'migratedUser.pendingMessage',
                      'Invitation is pending'
                    )}
                  </span>
                )}
            </div>
            {email !== '' && !dummyEmailRegex.test(email) && (
              <div
                data-testid="qa-email"
                className="user-list-item mb-1 user-colon-align">
                <span className="font-weight-bold">
                  {i18nTranslate('user.status', 'Status')}
                </span>
                <span>
                  :{'  '} {}
                  {user?.status === 'ACTIVE'
                    ? i18nTranslate('user.active', 'ACTIVE')
                    : i18nTranslate('user.pending', 'PENDING')}
                </span>
              </div>
            )}
            {/* <div data-testid="qa-user-id" className="user-list-item mb-1">
              <span className="user-colon-align-left">
                {i18nTranslate("user.id", "")}
              </span>
              : {id}
            </div> 
            <div data-testid="qa-user-name" className="user-list-item mb-1">
              <span className="user-colon-align-left">
                {i18nTranslate("user.nameHeaing", "User Name")}
              </span>
              :{''}
              <span>
                {firstName} {lastName}
              </span>
            </div>
            <div data-testid="qa-email" className="user-list-item mb-1, "
              <span className"="user-colon-align-left, "
                {i18n.t"("user.email", "Email")}
              </span>
              <span className="email-text">: {email}</span>
            </div>
             {isAdminEmail === false && !isB2B2C() && (
              <div data-testid="qa-team" className="user-list-item mb-1">
                <span className="user-colon-align-left">
                  {i18nTranslate("user.team", "Team")}
                </span>
                : {team}
              </div>
            )}  */}
          </Col>
          {/* <Col lg={4}>
            <div data-testid="qa-role" className="user-list-item mb-1">
              <span className="user-colon-align-right">
                {i18nTranslate("user.role", "Role")}
              </span>
              : {role}
            </div> 
            <div data-testid="qa-role" className="user-list-item mb-1 user-colon-align">
                <span>{i18nTranslate("user.role", "Contact")}</span>
                <span>: {phoneNumber}</span>
            </div>
             <div data-testid="qa-role" className="user-list-item mb-1">
              <span className="user-colon-align-right">
                {i18nTranslate("user.role", "Role")}
              </span>
              : {role}
            </div>
            <div data-testid="qa-status" className="user-list-item mb-1">
              <span className="user-colon-align-right">
                {i18nTranslate("user.status", "Status")}
              </span>
              : <span className={statusStyle}>{statusLabel}</span>
            </div> 
          </Col> */}
        </Row>
      </div>
    )
  }

  usersList = (user, index) => {
    const isVisible = this.userId === index ? this.isActive : false
    const { userId = '', id = '', email = '', customProperties = {} } = user
    const formInput = renderUserInviteFormInput({ isFromUserListCard: true })
    const schema = userInviteFormschema({ isFromUserListCard: true })
    const isToEnableAssociateInvite =
      APPConfig?.getAppConfig()?.enableAssociateInvite == 'true' || false
    const enableJointAccountParticipants = convertToBoolean(
      APPConfig?.getAppConfig()?.enableJointAccountParticipants
    )

    const enableJointAccountParticipantsInvite = isFeatureEnabled(
      'enableJointAccountParticipantsInvite'
    )
    const shouldShowInvitationActions =
      isToEnableAssociateInvite ||
      (enableJointAccountParticipants && enableJointAccountParticipantsInvite)

    return (
      // index > 0 && (
      <div
        className="bg-white mb-2"
        key={index}
        data-testid="qa-list-user-management">
        <AccordionBlock
          hasArrow={isB2B2C() ? false : true}
          title={this.renderUserListHeader(user)}
          key={index}
          isActive={isVisible}
          /*onClick={this.toggleEditUser}*/
          index={index}
          className={'user-list-accordian-wrapper'}>
          {/* <EditUsersList
            onToggle={this.toggleEditUser}
            user={user}
            {...this.props}
          /> */}
        </AccordionBlock>
        {this.isEmailOpen && this.migratedUserId === id && (
          <div className="userLisdtCard-button-container">
            <CommonForm
              schema={schema}
              formTypeJson={formInput}
              SubmitButtonProps={this.props?.renderSendInviteButton}
              hasInlineSubmitButton={false}
              onSubmit={data => this.sendMigratedUserInvitation(data, id)}
            />
            <Button
              className="userListCard-cancel-button justify-content-center align-items-center"
              variant="outline-primary"
              onClick={this.handleAddEmail}>
              {i18nTranslate('associate.cancel', 'Cancel')}
            </Button>
          </div>
        )}
        <Row className="userLisdtCard-button-container p-0">
          {isToEnableAssociateInvite &&
            (email === '' || dummyEmailRegex.test(email)) &&
            this.migratedUserId !== id && (
              <Col className="userLisdtCard-button">
                <Button
                  variant="primary"
                  className="add-intivation-button justify-content-center align-items-center"
                  onClick={() => this.handleAddEmail(id)}>
                  {i18nTranslate('associate.addEmail', 'Add Email')}
                </Button>
              </Col>
            )}
          {/* Using internal shouldShowInvitationActions instead of props */}
          {shouldShowInvitationActions &&
            email !== '' &&
            !dummyEmailRegex?.test(email) &&
            customProperties?.associateInvitationStatus ===
              'INVITATION_SENT' && (
              <>
                <Col className="userLisdtCard-button">
                  <Button
                    variant="primary"
                    className="resend-intivation-button justify-content-center align-items-center d-block"
                    onClick={() => this.handleResendInvitation(id)}>
                    {i18nTranslate(
                      'associate.resendInvitation',
                      'Resend Invitation'
                    )}
                  </Button>
                </Col>
                <Col className="userLisdtCard-button">
                  <Button
                    variant="outline-primary"
                    className="delete-intivation-button justify-content-center align-items-center"
                    onClick={() => this.handleDeleteIvitation(id, userId)}>
                    {i18nTranslate(
                      'associate.deleteInvitation',
                      'Delete Invitation'
                    )}
                  </Button>
                </Col>
              </>
            )}
        </Row>
      </div>
    )
  }
  render() {
    const { userData } = this.props
    const userId = customerContainer?.userId
    let buyerInfoList = []
    userData.map(user => {
      if (userId !== user?.id) {
        buyerInfoList.push(user)
      }
    })
    return (
      <div data-testid="qa-list-user-management">
        {buyerInfoList && buyerInfoList.map(this.usersList)}
      </div>
    )
  }
}

export default UsersListCard
export { UsersListCard }
